(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });


        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Stockist Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_category_toggle_block(
          '.js-stockist-category',            // Button / Category Class
          '.js-stockist-dropdown',            // Bootstrap Dropdown Class
          '.js-stockist-categories-content'   // Accordion Wrapper Class
        );

      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);




  $(document).ready(function () {
    
    ////////////////////////////////////////////////////////////////////////////////////
    // Primary button Micro Animation
    ////////////////////////////////////////////////////////////////////////////////////
    $('.js-btn-primary').hover(
        function () {
           $(this).addClass('is-hover'); 
        },
        function () {
           $(this).removeClass('is-hover'); 
        }
    );


    ////////////////////////////////////////////////////////////////////////////////////
    // Sticky Anchor Menu
    ////////////////////////////////////////////////////////////////////////////////////
    (function ($) {

      const $win = $(window);
      const $container = $('.page-header-carousel');
      const $menu = $('.js-page-header-menu');

      let wasStuck = null;

      function isMobile() { return $win.width() < 768; }

      function updateMenu() {
        if (!$container.length || !$menu.length) return;

        const scrollTop = $win.scrollTop();
        const vh = $win.height();

        const containerOffset = isMobile() ? 20 : 58; // only used at scrollTop 0
        const stuckOffset     = isMobile() ? 20 : 10; // used for any scroll > 0

        const isNowStuck = scrollTop > 0; // <-- only container-relative at exact top

        // transition only when switching modes
        if (wasStuck !== null && isNowStuck !== wasStuck) {
          $menu.addClass('enable-transition');
          setTimeout(() => $menu.removeClass('enable-transition'), 250);
        }

        let lift;

        if (!isNowStuck) {
          // container-relative ONLY at scrollTop 0
          const containerBottom =
            $container.offset().top + $container.outerHeight();

          const containerBottomInViewport = containerBottom - scrollTop; // scrollTop is 0 here
          const desiredBottomY = containerBottomInViewport - containerOffset;

          lift = vh - desiredBottomY;
        } else {
          // viewport-relative for any scroll > 0
          lift = stuckOffset;
        }

        $menu[0].style.setProperty('--menuShiftY', `${-lift}px`);

        wasStuck = isNowStuck;
      }

      let ticking = false;
      $win.on('scroll resize', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateMenu();
          ticking = false;
        });
      });

      updateMenu();

    })(jQuery);


    ////////////////////////////////////////////////////////////////////////////////////
    // Sticky CTA
    ////////////////////////////////////////////////////////////////////////////////////
    jQuery(function ($) {
      $(window).on('scroll', function () {
        $('.sticky-cta').toggleClass('is-visible', $(this).scrollTop() >= 120);
      });
    });

    ////////////////////////////////////////////////////////////////////////////////////
    // Mobile Menu Toggle
    ////////////////////////////////////////////////////////////////////////////////////
    jQuery(function ($) {
      $('.page-header-menu-toggle').on('click', function () {
        const $toggle = $(this);
        const $menu = $toggle
          .closest('.page-header-menu')
          .find('.page-header-menu-dropdown');

        $toggle.toggleClass('is-active');
        $menu.toggleClass('is-open');

        $toggle.attr(
          'aria-expanded',
          $toggle.hasClass('is-active') ? 'true' : 'false'
        );
      });
    });



    ////////////////////////////////////////////////////////////////////////////////////
    // Header Logo Switch
    ////////////////////////////////////////////////////////////////////////////////////
    jQuery(function ($) {
      const $brand = $('.navbar-brand.switch');
      const THRESHOLD = 300;
      function swapLogo() { $brand.toggleClass('is-swapped', $(window).scrollTop() > THRESHOLD); }
      $(window).on('scroll resize', swapLogo);
      swapLogo();
    });



    ////////////////////////////////////////////////////////////////
    // QUICK LINKS
    ////////////////////////////////////////////////////////////////
    jQuery(document).on('mouseenter mouseleave', '.js-flexi-quicklinks-row-text .marquee .flexi-quicklinks-row-link', function(e) {
      if (window.innerWidth > 992) {
          const obj = jQuery(this);
          const id = obj.attr('data-id');
          const img = obj.closest('.flexi-quicklinks-row-text').find('.flexi-quicklinks-row-image-' + id);

          jQuery('.flexi-quicklinks-row-image').removeClass('active');
          img.css('position', 'absolute');

          // Store timeout on the image element
          if (!img.data('timeoutId')) img.data('timeoutId', null);

          if (e.type === 'mouseenter') {
              const parent = obj.closest('.js-flexi-quicklinks-row-text');
              const parentLeft = parent.offset().left;
              const mouseX = e.pageX - parentLeft;
              const viewportWidth = jQuery(window).width();
              const imageWidth = img.outerWidth();
              const offset = 20; // spacing from cursor

              // Horizontal position
              let leftPos = ((mouseX + imageWidth + offset) > viewportWidth) 
                  ? mouseX - imageWidth - offset 
                  : mouseX + offset;
              
              img.css({ left: leftPos + 'px' });

              // Clear any previous timeout
              if (img.data('timeoutId')) clearTimeout(img.data('timeoutId'));

              const timeoutId = setTimeout(function(){
                img.addClass('active');
                img.data('timeoutId', null);
              }, 250);

              img.data('timeoutId', timeoutId);

          } else if (e.type === 'mouseleave') {
              // Clear timeout if still pending
              if (img.data('timeoutId')) {
                  clearTimeout(img.data('timeoutId'));
                  img.data('timeoutId', null);
              }
              img.removeClass('active');
          }
      }
    });


    
    ////////////////////////////////////////////////////////////////
    // Ticker Tape
    ////////////////////////////////////////////////////////////////
    if (typeof window.initFlexiTickerTape === 'function') { window.initFlexiTickerTape(); }
    // re-init on resize
    $(window).on('resize', function () {
      $('.js-marquee-track').each(function () {
        $(this).removeData('marqueeInit');
      });
      if (typeof window.initFlexiTickerTape === 'function') { window.initFlexiTickerTape(); }
    });


    ////////////////////////////////////////////////////////////////
    // Logo Slider
    ////////////////////////////////////////////////////////////////
    window.addEventListener('DOMContentLoaded', flexiLogoSliderinit);
    window.addEventListener('load', flexiLogoSliderinit);
    let logoSliderResizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(logoSliderResizeTimeout);
      logoSliderResizeTimeout = setTimeout(flexiLogoSliderinit, 300);
    });




    ////////////////////////////////////////////////////////////////
    // Event Carousel
    ////////////////////////////////////////////////////////////////




    ////////////////////////////////////////////////////////////////
    // Gallery Carousel Slider
    ////////////////////////////////////////////////////////////////
    function initGalleryCarousel($wrapper){

      //const $wrapper =  $container.find('.custom-carousel-wrapper');
      const $viewport = $wrapper.find('.custom-carousel-viewport');
      const $carousel = $wrapper.find('.custom-carousel');
      const $cells = $carousel.children('.carousel-cell');
      const $prevBtn = $wrapper.find('.carousel-prev');
      const $nextBtn = $wrapper.find('.carousel-next');
      const $captionOutput = $('#active-caption');

      let autoPlayTimer = null;
      const autoPlayDelay = 3000;

      let cellWidth = $cells.outerWidth(true);
      const totalCells = $cells.length;

      const $dotsTrack = $wrapper.find('.js-carousel-dots');
      let $dots = $();

      // Clone for infinite loop
      $carousel.prepend($cells.clone());
      $carousel.append($cells.clone());

      let currentIndex = totalCells;
      let isAnimating = false;
      let animFrame = null;
      let isDragging = false;
      let startX = 0, dragDelta = 0, velocity = 0, lastX = 0, lastTime = 0;


      function startAutoplay(){
        stopAutoplay();
        autoPlayTimer = setInterval(function(){
          if(!isDragging && !isAnimating){
            goToSlide(currentIndex + 1);
          }
        }, autoPlayDelay);
      }

      function stopAutoplay(){
        if(autoPlayTimer){
          clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }
      }


      // --- Build dots (one per REAL slide) ---
      function buildDots(){
        $dotsTrack.empty();
        for (let i = 0; i < totalCells; i++){
          $dotsTrack.append(`<button type="button" class="carousel-dot" data-index="${i}" aria-label="Go to slide ${i+1}"></button>`);
        }
        $dots = $dotsTrack.find('.carousel-dot');
      }

      function updateDots(){
        const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
        $dots.removeClass('is-active').eq(realIndex).addClass('is-active');
      }

      buildDots();


      // --- Update caption ---
      function updateCaption() {
        const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
        const caption = $cells.eq(realIndex).find('.carousel-caption').text();
        const pageNumber = `${realIndex + 1}/${totalCells} `;
        $captionOutput.html('<span class="_h5">'+pageNumber+'</span>' + caption);

        updateActiveCell();
        updateDots();
      }

      // --- Highlight active slide ---
      function updateActiveCell() {
          const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
          // Remove existing active class
          $carousel.find('.carousel-cell').removeClass('active');
          // Add active to the real cell (NOT the cloned ones)
          $cells.eq(realIndex).addClass('active');
      }

      // --- Freeze current position (mid-transition) ---
      function freezePosition() {
        const style = window.getComputedStyle($carousel[0]);
        const matrix = style.transform;

        let currentX = -currentIndex * cellWidth;

        if (matrix && matrix !== 'none') {
          const values = matrix.match(/matrix.*\((.+)\)/)[1].split(',');
          currentX = parseFloat(values[4]);
        }

        $carousel.css({
          transition: 'none',
          transform: `translateX(${currentX}px)`
        });

        $carousel[0].offsetHeight; // force reflow
        return currentX;
      }

      // --- Go to specific slide safely ---
      function goToSlide(targetIndex) {
        if (isAnimating) return;
        isAnimating = true;

        const currentTransform = freezePosition();
        const distance = -targetIndex * cellWidth;
        const diff = distance - currentTransform;
        //const duration = Math.min(500, Math.max(300, Math.abs(diff)));
        const duration = window.innerWidth < 992 ? 400 : 600;

        let start = null;

        function animateSlide(timestamp) {
          if (!start) start = timestamp;
          const progress = Math.min((timestamp - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const pos = currentTransform + diff * eased;
          $carousel.css('transform', `translateX(${pos}px)`);

          if (progress < 1) {
            animFrame = requestAnimationFrame(animateSlide);
          } else {
            currentIndex = targetIndex;

            // Handle infinite loop wrapping
            if (currentIndex >= totalCells * 2) currentIndex = totalCells;
            if (currentIndex < totalCells) currentIndex = totalCells * 2 - 1;

            $carousel.css('transition', 'none');
            $carousel.css('transform', `translateX(${-currentIndex * cellWidth}px)`);
            updateCaption();
            isAnimating = false;
          }
        }

        animFrame = requestAnimationFrame(animateSlide);
      }
      
      // --- Button navigation ---
      $nextBtn.on('click', function(){
        goToSlide(currentIndex + 1);
      });

      $prevBtn.on('click', function(){
        goToSlide(currentIndex - 1);
      });

      // --- Drag ---
      $carousel.on('mousedown touchstart', function(e){
        // Ignore right or middle mouse buttons
        if (e.type === 'mousedown' && e.button !== 0) return;
        if (isAnimating) return;
        isDragging = true;
        $carousel.css('transition','none');
        startX = e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX;
        lastX = startX;
        lastTime = Date.now();
        cancelAnimationFrame(animFrame);
      });

      $(document).on('mousemove touchmove', function(e){
        if (!isDragging) return;
        const x = e.type === 'touchmove' ? e.originalEvent.touches[0].clientX : e.clientX;
        const now = Date.now();
        const delta = x - lastX;
        velocity = delta / (now - lastTime);
        lastX = x;
        lastTime = now;

        //dragDelta = (x - startX) * 0.6;
        dragDelta = (x - startX);
        const offset = -currentIndex * cellWidth + dragDelta;
        $carousel.css('transform', `translateX(${offset}px)`);
      });

      $(document).on('mouseup touchend', function(){
        if (!isDragging) return;
        isDragging = false;

        const momentum = velocity * 250;
        const totalMove = dragDelta + momentum;

        let targetIndex = currentIndex;
        if (totalMove < -70) targetIndex++;
        else if (totalMove > 70) targetIndex--;

        goToSlide(targetIndex);

        dragDelta = 0;
        velocity = 0;
      });

      // --- Dot Click ---
      $dotsTrack.on('click', '.carousel-dot', function(){
        const realIndex = parseInt(this.dataset.index, 10);
        // Your "real" slides are centered starting at `totalCells`
        goToSlide(totalCells + realIndex);
      });

      // --- Window resize ---
      $(window).on('resize', function(){
        cellWidth = $carousel.children('.carousel-cell').outerWidth(true);
        $carousel.css('transition', 'none');
        $carousel.css('transform', `translateX(${-currentIndex * cellWidth}px)`);
      });

      // --- Initial position ---
      $carousel.css('transform', `translateX(${-currentIndex * cellWidth}px)`);
      updateCaption();
      updateDots();
      startAutoplay();

      // --- Custom Cursor ---
      const $cursor = $wrapper.find('.custom-carousel-cursor');

      let mouseX = 0, mouseY = 0;
      let cursorX = 0, cursorY = 0;

      function setMouseFromEvent(e){
        const evt = e.type.startsWith('touch')
          ? e.originalEvent.touches[0]
          : e;

        const rect = $viewport[0].getBoundingClientRect();

        mouseX = evt.clientX - rect.left;
        mouseY = evt.clientY - rect.top;
      }

      // Track only inside viewport
      $viewport.on('mousemove touchmove', function(e){
        setMouseFromEvent(e);
      });

      // Show / hide
      $viewport.on('mouseenter', function(){
        $cursor.css('opacity', '1');
      });

      $viewport.on('mouseleave', function(){
        $cursor.css('opacity', '0');
      });


      $wrapper.on('mouseenter', stopAutoplay);
      $wrapper.on('mouseleave', startAutoplay);

      $carousel.on('mousedown touchstart', stopAutoplay);

      $(document).on('mouseup touchend', function(){
        if(!isDragging){
          startAutoplay();
        }
      });


      function animateCursor() {
        cursorX += (mouseX - cursorX) * 0.2;
        cursorY += (mouseY - cursorY) * 0.2;

        $cursor.css(
          'transform',
          `translate(${cursorX - $cursor.outerWidth()/2}px, ${cursorY - $cursor.outerHeight()/2}px)`
        );

        requestAnimationFrame(animateCursor);
      }

      animateCursor();

    }

    // Init all carousels on page
    $('.section-flexi-gallery-carousel .custom-carousel-wrapper').each(function(){
      initGalleryCarousel($(this));
    });





    function updateFooterIconSpacers() {
      $('.footer-icon-row').each(function () {

        const $cols = $(this).children('.footer-icon-col');

        $cols.each(function () {

          const $col = $(this);
          const isSpacerCol = $col.find('.footer-icon-col-spacer').length > 0;

          if (!isSpacerCol) return;

          const $prevCol = $col.prev('.footer-icon-col');
          const $nextCol = $col.next('.footer-icon-col');

          $col.removeClass('is-hidden');

          const top = Math.round($col[0].getBoundingClientRect().top);

          // hide if no prev or next column
          if (!$prevCol.length || !$nextCol.length) {
            $col.addClass('is-hidden');
            return;
          }

          const prevTop = Math.round($prevCol[0].getBoundingClientRect().top);
          const nextTop = Math.round($nextCol[0].getBoundingClientRect().top);

          // hide if spacer starts a row OR ends a row
          if (prevTop !== top || nextTop !== top) {
            $col.addClass('is-hidden');
          }

        });

      });
    }

    let footerIconSpacerTimer;

    function refreshFooterIconSpacers() {
      clearTimeout(footerIconSpacerTimer);
      footerIconSpacerTimer = setTimeout(updateFooterIconSpacers, 30);
    }

    $(window).on('load resize', refreshFooterIconSpacers);
    $('.footer-icon-row img').on('load', refreshFooterIconSpacers);
    setTimeout(updateFooterIconSpacers, 150);

    

    ////////////////////////////////////////////////////////////////////
    // SITEWIDE ALERT
    //
    // Weather / cancellation notice. Waits for the page to settle (including
    // any hash scroll) before opening, then hands over to the persistent bar
    // when the modal is closed.
    ////////////////////////////////////////////////////////////////////
    const $alert = $('.js-cpk-alert');

    if ($alert.length) {

      const $alertBar = $('.js-cpk-alert-bar');
      const alertEl = $alert[0];
      const dialogEl = alertEl.querySelector('.cpk-alert-dialog');
      const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
      let lastFocused = null;

      /**
       * Open the alert modal and lock the page behind it.
       *
       * @since 1.0.0
       * @return {void}
       */
      function openAlert() {
        lastFocused = document.activeElement;
        hideAlertBar();
        $alert.addClass('show');
        $('html, body').addClass('cpk-alert-open');
        dialogEl.setAttribute('tabindex', '-1');
        window.setTimeout(function () { dialogEl.focus(); }, 60);
      }

      /**
       * Close the alert modal and reveal the persistent bar.
       *
       * @since 1.0.0
       * @return {void}
       */
      function closeAlert() {
        $alert.removeClass('show');
        $('html, body').removeClass('cpk-alert-open');
        showAlertBar();

        // Nothing triggered the alert on an automatic open, so only hand focus
        // back when it came from a real control.
        if (lastFocused && lastFocused !== document.body && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      /**
       * Slide the persistent bar into view.
       *
       * @since 1.0.0
       * @return {void}
       */
      function showAlertBar() {
        if (!$alertBar.length || $alertBar.data('dismissed')) {
          return;
        }

        $alertBar.prop('hidden', false);
        window.requestAnimationFrame(function () { $alertBar.addClass('show'); });
      }

      /**
       * Hide the persistent bar without dismissing it for good.
       *
       * @since 1.0.0
       * @return {void}
       */
      function hideAlertBar() {
        $alertBar.removeClass('show').prop('hidden', true);
      }

      /**
       * Run a callback once the page has stopped scrolling, so a hash link
       * lands on its target before the modal takes over the viewport.
       *
       * The theme scrolls to its `data-scroll-element` targets 500ms after
       * load (nous_anchor_link_hash), and lazy images can shift the page
       * again after that, so wait out a minimum delay and then watch the
       * scroll position until it holds steady.
       *
       * @since 1.0.0
       * @param {Function} callback Runs when the scroll position settles.
       * @return {void}
       */
      function whenScrollSettles(callback) {
        if (window.location.hash.length < 2) {
          callback();
          return;
        }

        const POLL = 100;
        const MIN_WAIT = 800;
        const LIMIT = 4000;
        let elapsed = 0;
        let previous = -1;

        const timer = window.setInterval(function () {
          const current = Math.round(window.pageYOffset);
          elapsed += POLL;

          if ((elapsed >= MIN_WAIT && current === previous) || elapsed >= LIMIT) {
            window.clearInterval(timer);
            callback();
            return;
          }

          previous = current;
        }, POLL);
      }

      $(window).on('load', function () {
        whenScrollSettles(openAlert);
      });

      $(document).on('click', '.js-cpk-alert-close', closeAlert);

      $alert.on('click', function (event) {
        if (event.target === alertEl) {
          closeAlert();
        }
      });

      $(document).on('keydown', function (event) {
        if (!$alert.hasClass('show')) {
          return;
        }

        if (event.key === 'Escape') {
          closeAlert();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        const items = dialogEl.querySelectorAll(FOCUSABLE);

        if (!items.length) {
          return;
        }

        const first = items[0];
        const last = items[items.length - 1];
        const active = document.activeElement;

        // Focus sits on the dialog itself when the alert opens, so pull it
        // into the panel rather than letting Tab escape to the page behind.
        if (!dialogEl.contains(active) || active === dialogEl) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
          return;
        }

        if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      });

      $(document).on('click', '.js-cpk-alert-reopen', openAlert);

      $(document).on('click', '.js-cpk-alert-bar-close', function () {
        $alertBar.data('dismissed', true);
        hideAlertBar();
      });

    }



  }); /* DOCUMENT READY */

        

  





})(jQuery); // Fully reference jQuery after this point.


window.addEventListener('load', function () {

  ////////////////////////////////////////////////////////////////////
  // AOS RECALCULATE
  ////////////////////////////////////////////////////////////////////
  AOS.refreshHard();


}); // END WINDOW LOAD




